<template>
  <div class="box">
    <tablePackaging
      :tableListData="postList"
      :tableOption.sync="tableOption"
      :isOperate="isOperate"
      :page="page"
      :searchFormList="searchFormList"
      @update="getTableChangePageData"
      @searchDate="getTableData"
      @deleteDate="deleteDate"
    >
      <template v-slot:header>
        <div class="btn-wrap">
          <div class="left-wrap"></div>
          <div class="right-wrap">
            <el-button type="primary" @click="handelClickAdd" size="small"
              >添加</el-button
            >
          </div>
        </div>
      </template>
      <template slot-scope="scope" slot="operate">
        <el-tooltip
          class="item"
          popper-class="popper-class"
          content="上移"
          placement="bottom-end"
        >
          <!-- v-if="scope.row.username != 'admin'" -->
          <el-button
            icon="el-icon-upload2"
            circle
            size="20"
            type="success"
            @click="upTransposition(scope.row)"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          popper-class="popper-class"
          content="下移"
          placement="bottom-end"
        >
          <!-- v-if="scope.row.username != 'admin'" -->
          <el-button
            icon="el-icon-download"
            circle
            size="20"
            type="success"
            @click="downTransposition(scope.row)"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          popper-class="popper-class"
          content="编辑放假日历"
          placement="bottom-end"
        >
          <!-- v-if="scope.row.username != 'admin'" -->
          <el-button
            icon="el-icon-date"
            circle
            size="20"
            type="success"
            @click="handelClickDate(scope.row)"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          popper-class="popper-class"
          content="编辑"
          placement="bottom-end"
        >
          <!-- v-if="scope.row.username != 'admin'" -->
          <el-button
            icon="el-icon-edit-outline"
            circle
            size="20"
            type="success"
            @click="handelClickEdit(scope.row)"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          popper-class="popper-class"
          content="删除"
          placement="bottom-end"
        >
          <el-button
            icon="el-icon-delete"
            circle
            type="success"
            @click="handleDelete(scope.row)"
          ></el-button>
        </el-tooltip>
      </template>
    </tablePackaging>
    <countryAdd
      ref="countryAdd"
      :title="title"
      @upData="getTableData"
      :rowDetail="rowDetail"
    ></countryAdd>
    <chooseCalendar
      ref="chooseCalendar"
      :title="title"
      @upData="getTableData"
      :rowDetail="rowDetail"
    ></chooseCalendar>
  </div>
</template>
  
  <script>
import {
  countryQuery,
  countryMoveUp,
  countryMoveDown,
  deletecountry,
  countryCalendarDelete,
} from '@/api/country';
import tablePackaging from '@/components/tablePackaging';
import countryAdd from './component/countryAdd';
import chooseCalendar from './component/chooseCalendar';
import { clone } from '@/utils/utils';

const defaultSearchObj = {
  page: {
    pageNum: 1,
    pageSize: 10,
  },
  searchInfo: {
    equipmentName: '',
    equipmentStationName: '',
  },
};
export default {
  data() {
    return {
      title: '新建国家',
      postList: [],
      isOperate: true,
      searchFormList: [],
      tableOption: [
        //是否展示多选
        // {
        //   type: 'selection',
        //   label: '#',
        // },
        {
          prop: 'countryName',
          label: '国家名字',
          overHidden: true,
          //sortable: 'orgName',
        },
        {
          prop: 'countryPinyin',
          label: '国家拼音',
          overHidden: true,
          //sortable: 'name',
        },
        {
          otherType: 'fromContinent',
          prop: 'continentList',
          label: '所属大洲',
          overHidden: true,
          //sortable: 'name',
        },
        {
          prop: 'countryPinYinFirstLetter',
          label: '首字母',
          overHidden: true,
          //sortable: 'name',
        },
        {
          otherType: 'titlePictureUrl',
          prop: 'backgroundPictureUrl',
          label: '背景图',
          overHidden: true,
          //sortable: 'orgName',
        },
        {
          otherType: 'titlePictureUrl',
          prop: 'nationPictureUrl',
          label: '国旗',
          overHidden: true,
          //sortable: 'orgName',
        },
        {
          otherType: 'calendarDate',
          prop: 'calendarList',
          label: '放假日历',
          overHidden: true,
          width: '500',
          //sortable: 'name',
        },
      ],
      searchObj: clone(defaultSearchObj),

      page: {
        pageNum: 1, //起始位置
        pageSize: 10, //每页条数
        totalCount: null, //总条数
      },
      rowDetail: {},
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    getTableData() {
      countryQuery(this.searchObj.page).then((res) => {
        if (res.code == 200) {
          console.log(res.data.records);
          this.postList = res.data.records;
          this.page.pageNum = res.data.pageNum;
          this.page.pageSize = res.data.pageSize;
          this.page.totalCount = res.data.total;
        }
      });
    },
    getTableChangePageData(obj) {
      this.searchObj.page.pageNum = obj.pageNum;
      this.searchObj.page.pageSize = obj.pageSize;
      this.getTableData();
    },
    //添加
    handelClickAdd() {
      this.title = '新建国家';
      this.rowDetail = {};
      this.$refs.countryAdd.DialogShow = true;
    },
    //修改
    handelClickEdit(row) {
      this.title = '编辑国家';
      this.rowDetail = row;

      // let continentList = [];
      // this.rowDetail.continentList.forEach((item) => {
      //   continentList.push(item.continentBid);
      // });
      // this.rowDetail.continentList = continentList;
      this.$refs.countryAdd.DialogShow = true;
    },
    //选择日历
    handelClickDate(row) {
      this.rowDetail = row;
      this.title = '放假日历';
      this.$refs.chooseCalendar.DialogShow = true;
    },
    //删除
    handleDelete(row) {
      this.$myConfirm
        .showMsgBox({
          title: '提示',
          // confirmBtnText: '一并删除',
          // cancelBtnText: '仅删除账号',
          tips: '',
          content: '确定删除该国家？',
        })
        .then(() => {
          deletecountry(row.countryBid).then((res) => {
            if (res.code == '200') {
              this.$msg.success('删除成功！');
              this.getTableData();
            }
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    upTransposition(row) {
      countryMoveUp(row.countryBid).then((res) => {
        if (res.code == 200) {
          this.$msg.success('操作成功！');
          this.getTableData();
        }
      });
      // if(row.rank -1  == 0){
      //   this.$msg('已经到顶了，无法上移！')
      // }
    },
    downTransposition(row) {
      countryMoveDown(row.countryBid).then((res) => {
        if (res.code == 200) {
          this.$msg.success('操作成功！');
          this.getTableData();
        }
      });
    },
    //删除日期
    deleteDate(date) {
      console.log(date);
      countryCalendarDelete(date.countryCalendarBid).then((res) => {
        // console.log(res.data)
        if (res.code == 200) {
          this.$msg.success('删除成功！');
          this.getTableData();
        }
      });
    },
  },

  components: {
    tablePackaging,
    countryAdd,
    chooseCalendar,
  },
};
</script>
  
  <style>
</style>